const timelineItems = [
  {
    id: 1,
    start: '2018-01-01',
    end: '2018-01-05',
    name: 'First item',
  },
  {
    id: 2,
    start: '2018-01-02',
    end: '2018-01-08',
    name: 'Second item',
  },
  {
    id: 3,
    start: '2018-01-06',
    end: '2018-01-13',
    name: 'Another item',
  },
  {
    id: 4,
    start: '2018-01-14',
    end: '2018-01-14',
    name: 'Another item',
  },
  {
    id: 5,
    start: '2018-02-01',
    end: '2018-02-15',
    name: 'Third item',
  },
  {
    id: 6,
    start: '2018-01-12',
    end: '2018-02-16',
    name: 'Fourth item with a super long name',
  },
  {
    id: 7,
    start: '2018-02-01',
    end: '2018-02-02',
    name: 'Fifth item with a super long name',
  },
  {
    id: 8,
    start: '2018-01-03',
    end: '2018-01-05',
    name: 'First item',
  },
  {
    id: 9,
    start: '2018-01-04',
    end: '2018-01-08',
    name: 'Second item',
  },
  {
    id: 10,
    start: '2018-01-06',
    end: '2018-01-13',
    name: 'Another item',
  },
  {
    id: 11,
    start: '2018-01-09',
    end: '2018-01-09',
    name: 'Another item',
  },
  {
    id: 12,
    start: '2018-02-01',
    end: '2018-02-15',
    name: 'Third item',
  },
  {
    id: 13,
    start: '2018-01-12',
    end: '2018-02-16',
    name: 'Fourth item with a super long name',
  },
  {
    id: 14,
    start: '2018-02-01',
    end: '2018-02-02',
    name: 'Fifth item with a super long name',
  },
];

export default timelineItems;



// WEBPACK FOOTER //
// ./src/timelineItems.js